// extracted by mini-css-extract-plugin
export default {"absolutePositionedItemHolder":"tVW2g9QdjCw2WOZs16HQ"};